import { h, render } from 'preact';
import { useState } from 'preact/hooks';
import { AddressAutocomplete, IAutocompleteProps, IAutocompleteResult } from "@noknoksoftware/address-autocomplete";
import { Hooks } from '@wordpress/hooks/build-types';

declare var wp : any;
declare var jQuery: any;
declare var fwData: {
    ajaxurl: string
}


( $ => {
    
    // Check jquery is running
    if( !$ ) {
        console.error( 'Could not load address-forms.js, global var jQuery is missing.' );
    } 

    const hooks = wp.hooks as Hooks;

    // Add User Defined Function to jquery to load address autocomplete to existing fields
    $.fn.fwAutocomplete = function( _props: IAutocompleteProps ) {

        // Hide original input field we are replacing
        var elem = this;
        elem.attr( 'type', 'hidden' );

        // Build wrapper
        var wrapper = jQuery( '<div class="fw-autocomplete"></div>' );
        elem.parent().append( wrapper );

        // Wrap Component so we can wrap props
        const _AddressAutocomplete = () => {

            // Wrap props in state so they can be used in external context
            var [ props, setProps ] = useState( _props );

            return (
                <AddressAutocomplete { ...props } 

                    // Wrap getFetchParams to inject custom action
                    getFetchParams={ params => {
                        
                        // Inject request arg "action"
                        if( params.body instanceof URLSearchParams ) {
                            params.body?.set?.( 'action', 'fw_address_autocomplete' );
                        }

                        // Wrap default
                        if( _props.getFetchParams ) {
                            params = _props.getFetchParams( params );
                        }

                        return params;
                    } }
                    
                    // Wrap onChange to update state so component can run outside react context
                    onChange={ ( value: IAutocompleteResult | undefined  ) => {

                        // Update state
                        setProps( { ...props, value: value ? value : undefined } );

                        // Call external on change
                        _props.onChange?.( value );
                    }}

                />
            )

        }

        // Render Autocomplete component
        render( <_AddressAutocomplete />, wrapper[0] );
        return {}
    }


    $( document ).ready( () => {

        
        // Sets up the frontend autocomplete preact field 
        [ 'billing_', 'shipping_' ].forEach( prefix => {

            const addressField           = $( '#' + prefix + 'fw_autocomplete' );
            const addressIdField         = $( '#' + prefix + 'fw_autocomplete_id' );

            var value = {
                id:      addressIdField.val(),
                address: addressField.val()
            } as IAutocompleteResult;

            var onChange = ( value: IAutocompleteResult | null ) => {
                addressIdField.val( value?.id || '' );
                addressField.val( value?.address || '' );
                addressField.trigger( 'change' );
                $('body').trigger('update_checkout');
            }

            addressField.fwAutocomplete( hooks.applyFilters( 'fw_address_autocomplete_props', {
                lookupUrl: fwData.ajaxurl,
                showStreetview: !$( 'body' ).hasClass('woocommerce-account'),
                onChange,
                value,
                inputProps: {}
            } as IAutocompleteProps ) );

        } );

        // Toggles form visibility for address autocomplete / manual entry and associated fields
        [ 'billing_', 'shipping_' ].forEach( prefix => {

            const countryField          = $( '#' + prefix + 'country_field' );
            const autocompleteField     = $( '#' + prefix + 'fw_autocomplete_field' );
            const manualEntryField      = $( '#' + prefix + 'fw_autocomplete_manual_entry_field' );
            const addressFields         = $( '[id^="' + prefix + '"].address-field' ).not( countryField ).not( autocompleteField );

            const address1              = $( '#'  + prefix + 'address_1_field');
            const addressCity           = $( '#'  + prefix + 'city_field');
            const addressState          = $( '#'  + prefix + 'state_field');
            const addressPostcode       = $( '#'  + prefix + 'postcode_field');

            const fieldsWithAddressValidation = [
                address1,
                addressCity,
                addressState,
                addressPostcode
            ].filter( field => field.hasClass( 'validate-required' ) );

            const update = () => {

                var countryCode = countryField.find( 'select' ).val();
                if( countryCode == '' ) {
                    addressFields.hide();
                    autocompleteField.hide(),
                    manualEntryField.hide();
                    fieldsWithAddressValidation.forEach( f => f.addClass( 'validate-required' ) );
                } 
                else if( countryCode != 'NZ') {
                    addressFields.show();
                    autocompleteField.hide();
                    manualEntryField.hide();
                    fieldsWithAddressValidation.forEach( f => f.addClass( 'validate-required' ) );
                
                } else if( manualEntryField.find( 'input' ).is( ':checked' ) ) {
                    addressFields.show();
                    autocompleteField.hide();
                    manualEntryField.show();
                    fieldsWithAddressValidation.forEach( f => f.addClass( 'validate-required' ) );

                } else {
                    addressFields.hide();
                    manualEntryField.show();
                    autocompleteField.show();
                    fieldsWithAddressValidation.forEach( f => f.removeClass( 'validate-required' ) );
                }
            }


            $( document.body ).on( 'country_to_state_changing', () => setTimeout( update, 1 ) );
            manualEntryField.find( 'input' ).change( update );
            setTimeout( update, 1 );
        } );

    } );

} )( jQuery );

/**
 * Loads data onto the Checkout Form so it can be available in WC rates / fees queries
 * @see checkout.js:319
 */
 ( $ => {

    const shipToDiffAddress = $( '#ship-to-different-address' ).find( 'input' );

    if( shipToDiffAddress.length == 0 ) {
        return;
    }

    const hiddenShipToDiffAddress = $( `<input type="hidden" name="ship_to_diff_address" />`);
    const checkoutForm = $('form.checkout');

    var state = {
        shipToDiffAddress: 0
    };

    function init() {
        state = {
            shipToDiffAddress: shipToDiffAddress.is( ':checked' )
        };

        checkoutForm.append( hiddenShipToDiffAddress );
        update();
    }

    function update() {
        hiddenShipToDiffAddress.val( state.shipToDiffAddress ? 1 : 0 );
    }

    shipToDiffAddress.click(function() {
        state.shipToDiffAddress = shipToDiffAddress.is( ':checked' );
        update();
    })

    init();

})( jQuery );